const storekeys = {
  vip_experience_60s: 'vip_experience_60s', // 领取免费 VIP
}
export default storekeys;
